import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParamsCameo, getLocaleFullName } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { notification } from 'antd'
import history from '../helpers/history';
import * as TagAction from '../actions/tagAction';
import * as TagService from './../services/tagService';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import { tagGroupDetailAutoTranslateRequest } from '../actions/autoTranslateAction';

function* getListTagGroupDetail() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_LIST_ACTION, Func.sagaWrapper(function* (action) {
    const params = parseListRequestParamsCameo(action.params || {});
    const result = yield call(TagService.getTagGroupDetails, params);
    yield put(TagAction.setListTagGroupDetails(result));
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* getTagGroupDetailItem() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
    const result = yield call(TagService.getTagGroupDetailItem, action.id);
    yield put(TagAction.setTagGroupDetailItem(result));
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* updateTagGroupDetail() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.updateTagGroupDetail, action.tagGroupDetail);
    Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.tagGroupDetails.title')} "${action.tagGroupDetail.name}"` })
    yield put(TagAction.setTagGroupDetailItem(action.tagGroupDetail));
    if (action.tagGroupDetail.targetLanguage && action.tagGroupDetail.targetLanguage.length > 0) {
      yield put(tagGroupDetailAutoTranslateRequest({
        sourceId: action.tagGroupDetail.id,
        sourceLanguage: 'vi-VN',
        targetLanguages: action.tagGroupDetail.targetLanguage,
        callbacks: action.callbacks
      }));
    } else if (action.callbacks?.onSuccess) {
      yield action.callbacks.onSuccess();
    }
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* createTagGroupDetail() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.createTagGroupDetail, action.tagGroupDetail);
    Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.tagGroupDetails.title')} "${action.tagGroupDetail.name}"` });
    yield delay(SAGA_DELAY_TIMEOUT);
    history.push(PATHS.TAG_GROUP_DETAIL.LIST.path);
    history.go();
    yield put(TagAction.setTagGroupDetailItem(action.tagGroupDetail));
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* deleteTagGroupDetail() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.deleteTagGroupDetail, action.tagGroupDetail);
    Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.tagGroupDetails.title')} "${action.tagGroupDetail.name}"` });
    yield delay(SAGA_DELAY_TIMEOUT);
    yield put(TagAction.getListTagGroupDetails(action.refreshParams || {}));
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* getAllTagGroup() {
  yield takeLatest(Types.TAG_GROUP_GET_ALL_ACTION, Func.sagaWrapper(function* (action) {
    const result = yield call(TagService.getAllTagGroup);
    yield put(TagAction.setAllTagGroup(result));
  }, errorHandleTag(Types.TAG_GROUP_FAIL)))
}

function* getAllSku() {
  yield takeLatest(Types.TAG_GROUP_GET_ALL_SKU_ACTION, Func.sagaWrapper(function* (action) {
    if (!action.typeKey) return
    const result = yield call(TagService.getAllSku, action.typeKey);
    yield put(TagAction.setAllSku(result, action.typeKey));
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* mapSku() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_MAP_SKU_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.mapSkus, action.params);
    Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.tagGroupDetails.title')}` })
    yield put(TagAction.mapSkuSuccess());
    const tagGroupDetailId = action.params.tagGroupDetailId;
    yield put({ type: Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION, id: tagGroupDetailId });
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

// TRANSLATE
function* createTagGroupDetailTranslate() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.createTagGroupDetailTranslate, action.tagGroupDetail);
    Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.tagGroupDetail.translate.languageName);
    yield put({ type: Types.TAG_GROUP_DETAIL_CREATE_TRANSLATE_SUCCESS });
    yield put({ type: Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION, id: action.tagGroupDetail.id });
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* updateTagGroupDetailTranslate() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.updateTagGroupDetailTranslate, action.tagGroupDetail);
    Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.tagGroupDetail.translate.languageName);
    yield put({ type: Types.TAG_GROUP_DETAIL_UPDATE_TRANSLATE_SUCCESS });
    yield put({ type: Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION, id: action.tagGroupDetail.id });
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* deleteTagGroupDetailTranslate() {
  yield takeLatest(Types.TAG_GROUP_DETAIL_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(TagService.deleteTagGroupDetailTranslate, action.tagGroupDetail.translate.id);
    Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.tagGroupDetail.translate.languageName);
    yield put({ type: Types.TAG_GROUP_DETAIL_DELETE_TRANSLATE_SUCCESS });
    yield put({ type: Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION, id: action.tagGroupDetail.id });
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* getTagInTagGroup() {
  yield takeLatest(Types.GET_TAG_IN_TAGGROUP_ACTION, Func.sagaWrapper(function* (action) {
    const params = parseListRequestParamsCameo(action.params || {});
    const result = yield call(TagService.getTagInTagGroup, params);
    yield put(TagAction.setTagIntagGroup(result));
    yield call(getAllData, result, params, TagService.getTagInTagGroup, TagAction.setTagIntagGroup)
  }, errorHandleTag(Types.TAG_GROUP_FAIL)))
}

function* getTagBySku() {
  yield takeLatest(Types.GET_TAG_BY_SKU_ACTION, Func.sagaWrapper(function* (action) {
    const result = yield call(TagService.getTagBySku, action.id);
    yield put(TagAction.setTagBySku(result));
  }, errorHandleTag(Types.TAG_GROUP_FAIL)))
}

function* updateTagGroupSKUMapping() {
  yield takeLatest(Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
    const { inserts, deletes } = action.skuTags;
    if(inserts.length > 0 || deletes.length > 0){
      yield call(TagService.updateTagGroupSKUMapping, action.skuTags);
      yield put({ type: Types.TAG_GROUP_SKU_MAPPING_UPDATE_SUCCESS });
    }
  }, errorHandleTag(Types.TAG_GROUP_DETAIL_FAIL)))
}

function* getAllData(data = [], params = {}, funcService, funcSetDataCallback) {
  const totalPage = Math.ceil(parseInt(data.totalCount) / parseInt(data.pageSize))
  if(data.result.length > 0 && totalPage > 1) {
      for(let page = 2; page <= totalPage; page++) {
          if(!!funcService && !!funcSetDataCallback && !!params) {
              const nextData = yield call(funcService, { ...params, pageIndex: page });
              yield put(funcSetDataCallback(nextData));
          }
      }
  }
}

function* getTagsByGroup() {
  yield takeLatest(Types.TAG_GROUP_GET_BY_TAG_GROUP_ACTION, Func.sagaWrapper(function* (action) {
    const result = yield call(TagService.getTagsByGroup, action.params);
    yield put(TagAction.setTagsByGroup(result));
  }, errorHandleTag(Types.TAG_GROUP_FAIL)))
}

function errorHandleTag(errorActionType) {
  return Func.sagaErrorHandler(function* (e) {
    yield put({ type: errorActionType })
  }, 'tag');
}


export function* tagSaga() {
  yield all([
    fork(getListTagGroupDetail),
    fork(getTagGroupDetailItem),
    fork(updateTagGroupDetail),
    fork(createTagGroupDetail),
    fork(deleteTagGroupDetail),
    fork(getAllTagGroup),
    fork(getAllSku),
    fork(mapSku),
    fork(createTagGroupDetailTranslate),
    fork(updateTagGroupDetailTranslate),
    fork(deleteTagGroupDetailTranslate),
    fork(getTagInTagGroup),
    fork(getTagBySku),
    fork(updateTagGroupSKUMapping),
    fork(getTagsByGroup)
  ])
}
